module.exports = __webpack_public_path__ + "static/media/Contactgirl.47901cf6.png";